<!--产品管理 产品列表 查看详情-->
<template>
  <div>
    <section>
      <el-table :show-header="false" :data="tableData" :span-method="objectSpanMethod" border :cell-style="columnStyle"
        style="width: 100%; margin-top: 20px">
        <el-table-column prop="id" label="ID" width="240">
          <template>
            <div>
              <img :src="tabData.PIC_URL" />
            </div>
          </template>
        </el-table-column>
        <el-table-column width="180" prop="name"></el-table-column>
        <el-table-column prop="amount1"></el-table-column>
        <el-table-column width="180" prop="amount2"></el-table-column>
        <el-table-column prop="amount3"></el-table-column>
      </el-table>
    </section>
  </div>
</template>
<script>
export default {
  name: 'mallMember-detail',
  data() {
    return {
      // 请求回来的数据
      dataForm: {},
      tabData: JSON.parse(sessionStorage.getItem('detailData')),
      // QGPList: ['年', '季', '月', '日', '时'],
      // warnList: ['年', '季', '月', '日', '时'],
      // pullOffList: ['年', '季', '月', '日', '时'],
      timeTypeList: ['', '年', '季', '月', '日', '时'],
      wayOut: ['MTO', 'MTS', 'DS'],
    };
  },
  computed: {
    // 因为数据用到了dataform中的数据，所以写在了computed中
    tableData() {
      return [
        {
          name: '名称',
          amount1: this.tabData.NAME,
          amount2: '编码',
          amount3: this.tabData.PRODUCT_CODE,
        },
        {
          name: '单位',
          amount1: this.tabData.TYPE_UNIT,
          amount2: '所属分类',
          amount3: this.tabData.CATALOG_NAME,
        },
        {
          name: '出库方式',
          amount1: this.wayOut[this.tabData.OW_TYPE - 1],
          amount2: '温区',
          amount3: this.tabData.WZ_TYPE_NAME,
        },
        {
          name: '原料产地',
          amount1: this.tabData.PRODUCING_AREA,
          amount2: '安全库存',
          amount3: this.tabData.SAFETY_STOCK,
        },
        {
          name: '保质期',
          amount1: this.tabData.QGP + this.timeTypeList[this.tabData.QGP_TIME_TYPE],
          amount2: '预警期',
          amount3: this.tabData.WARNING_PERIOD + this.timeTypeList[this.tabData.WP_TIME_TYPE],
        },
        {
          name: '下架期',
          amount1: this.tabData.PULL_OFF_PERIOD + this.timeTypeList[this.tabData.PO_TIME_TYPE],
          amount2: '库位编码',
          amount3: this.tabData.LOCATION_CODE,
        },
        {
          name: '购买产品',
          amount1: this.tabData.BUYED_NAME,
          amount2: '购买产品编码',
          amount3: this.tabData.BUYED_PRODUCT_CODE,
        },
        {
          name: '单位',
          amount1: this.tabData.BUYED_TYPE_UNIT,
          amount2: '出成比例',
          amount3: this.tabData.BUY_RATE,
        },
      ];
    },
  },
  methods: {
    // 自定义列背景色
    columnStyle({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex == 0 || columnIndex == 1 || columnIndex == 3) {
        // 第三第四列的背景色就改变了2和3都是列数的下标
        return 'background:#f3f6fc;';
      }
      return 'background:#ffffff;';
    },
    // 和并列
    objectSpanMethod({
      row, column, rowIndex, columnIndex,
    }) {
      if (columnIndex === 0) {
        if (rowIndex % 8 === 0) {
          return {
            rowspan: 8,
            colspan: 1,
          };
        }
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    },
    // 设置出库方式
    setOutWay(e) {
      return this.wayOut[e - 1];
    },
    // 设置保质期
    setQGP(e) {
      return this.timeTypeList[e];
    },
    // 设置预警期
    setWarn(e) {
      return this.timeTypeList[e];
    },
    // 设置下架期
    setPullOff(e) {
      return this.timeTypeList[e];
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/SKUManage/skuDetail.vue